import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';
import useIsTrialUrl from './useIsTrialUrl';

const useAuthenticateTrial = (url: string): void => {
    const isTrialUrl = useIsTrialUrl();
    const router = useRouter();

    useEffect(() => {
        if (isTrialUrl(url)) {
          router.navigate({ to: '/spaces/trial' });
        }
      }, [isTrialUrl, router, url]);
}

export default useAuthenticateTrial;